/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import '../../common/bank_account/bank_account_service';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "dashboard": {
            "nested": {
              "bank_account": {
                "nested": {
                  "BankAccountService": {
                    "methods": {
                      "CreatePlaidLinkSession": {
                        "requestType": "squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionRequest",
                        "responseType": "squareup.bbfrontend.common.bank_account.CreatePlaidLinkSessionResponse"
                      },
                      "CreateAndLinkBankAccountFromPlaidLink": {
                        "requestType": "squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkRequest",
                        "responseType": "squareup.bbfrontend.common.bank_account.CreateAndLinkBankAccountFromPlaidLinkResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.dashboard?.nested?.bank_account?.nested?.BankAccountService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BankAccountService @ squareup/bbfrontend/dashboardweb/bank_account/bank_account_service.proto at 13:1
 */
export const BankAccountService = $root.lookupService('squareup.bbfrontend.dashboard.bank_account.BankAccountService');